import React from "react";
import { Link } from "react-router-dom";

const ComponentHeader = ({ title }) => {
  return (
    <div className="row xcruit-page-header">
      <div className="col-12">
        <div className="page-title-box xc-page-crumb">
          <ol className="breadcrumb m-0 ms-auto">
            <li className="breadcrumb-item">
              <Link to="/dashboard" title="Home">
                <i className="ri-home-2-line"></i>
              </Link>
            </li>
            <li className="breadcrumb-item active">{title}</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default ComponentHeader;
